"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbBData = exports.MbAndroidBData = exports.MbIosBData = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const framework_1 = require("../../../framework");
const platform_1 = require("./platform");
var platform_2 = require("./platform");
Object.defineProperty(exports, "MbIosBData", { enumerable: true, get: function () { return platform_2.MbIosBData; } });
Object.defineProperty(exports, "MbAndroidBData", { enumerable: true, get: function () { return platform_2.MbAndroidBData; } });
const validBDataURLs = (...bdataURLs) => bdataURLs.every(bdataURL => bdataURL && bdataURL.trim());
class MbBData extends web_ui_framework_1.BaseLibrary {
    constructor(changeAntiFraudContext, urlConfig) {
        super();
        this.changeAntiFraudContext = changeAntiFraudContext;
        this.urlConfig = urlConfig;
    }
    isAndroidWithValidURLs() {
        return (0, web_ui_framework_1.isAndroidWebView)() && validBDataURLs(this.urlConfig.androidUrl);
    }
    isIosWithValidURLs() {
        return (0, web_ui_framework_1.isIosWebView)() && validBDataURLs(this.urlConfig.iosBridUrl, this.urlConfig.iosSecUrl);
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isAndroidWithValidURLs()) {
                this.instance = new platform_1.MbAndroidBData(this.urlConfig.androidUrl, this.changeAntiFraudContext);
                yield this.instance.load();
            }
            else if (this.isIosWithValidURLs()) {
                this.instance = new platform_1.MbIosBData(this.urlConfig.iosBridUrl, this.urlConfig.iosSecUrl, this.changeAntiFraudContext);
                yield this.instance.load();
            }
            else if (validBDataURLs(this.urlConfig.webUrl)) {
                this.instance = new framework_1.WebBData(this.urlConfig.webUrl);
                yield this.instance.load();
            }
            else {
                web_ui_framework_1.Log.warn('BData: There is no valid BDATA_WEB_URL configured');
            }
        });
    }
}
exports.MbBData = MbBData;
//# sourceMappingURL=index.js.map